export default Object.freeze({
  ArianeeAsset: 'https://cert.arianee.org/version1/ArianeeAsset.json',
  ArianeeProductCertificatei18n: 'https://cert.arianee.org/version1/ArianeeProductCertificate-i18n.json',
  ArianeeIdentity: 'https://cert.arianee.org/version1/ArianeeBrandIdentity-i18n.json',
  ArianeeEvent: 'https://cert.arianee.org/version1/ArianeeEvent-i18n.json',
  ArianeeMessageAlpha: 'https://cert.arianee.org/version1/ArianeeMessage-i18nAlpha.json',
  ArianeeMessage: 'https://cert.arianee.org/version1/ArianeeMessage-i18n.json'
});
